import cx from 'classnames';
import React from 'react';

import type { FCWithChildren } from 'types/react-extended';
import Styles from './styles.scss';

export interface NavSectionProps {
	children: React.ReactNode;
	className?: string;
	navId: string;
	shouldHide?: boolean;
}

const NavSection: FCWithChildren<NavSectionProps> = ({
	children,
	className = '',
	navId,
	shouldHide = false,
}) => {
	return shouldHide ? null : (
		<div
			id={navId}
			data-testid={`nav-section-${navId}`}
			className={cx(className, Styles.sectionWrapper)}
		>
			{children}
		</div>
	);
};

export default NavSection;
